import {useDebugValue} from 'react';

import {runHPPrePopulateCookieExperiment} from '../../../utils';

import {useValues} from './';

const defaultDatesValues = {
    startDate: '',
    endDate: ''
};

function useDatesValues(props, searchCookies, systemOptions, abacusStore) {
    const {
        datesValues: propsDatesValues
    } = props;

    let {
        datesValues: cookiesDatesValues
    } = searchCookies;

    cookiesDatesValues = runHPPrePopulateCookieExperiment(abacusStore, systemOptions, searchCookies) ? {} : cookiesDatesValues;

    const {
        initialValues: initialDatesValues,
        currentValues: currentDatesValues,
        latestValues: latestDatesValues,
        setCurrentValues: setCurrentDatesValues,
        setCurrentValuesDefault: setCurrentDatesValuesDefault,
        setCurrentValuesInitial: setCurrentDatesValuesInitial,
        setCurrentValuesLatest: setCurrentDatesValuesLatest,
        setLatestValues: setLatestDatesValues,
        setLatestValuesDefault: setLatestDatesValuesDefault,
        setLatestValuesInitial: setLatestDatesValuesInitial,
        setLatestValuesCurrent: setLatestDatesValuesCurrent,
        setAllValues: setAllDatesValues,
        setAllValuesDefault: setAllDatesValuesDefault,
        setAllValuesInitial: setAllDatesValuesInitial
    } = useValues(defaultDatesValues, cookiesDatesValues, propsDatesValues);

    const result = {
        defaultDatesValues,
        initialDatesValues,
        currentDatesValues,
        latestDatesValues,
        setCurrentDatesValues,
        setCurrentDatesValuesDefault,
        setCurrentDatesValuesInitial,
        setCurrentDatesValuesLatest,
        setLatestDatesValues,
        setLatestDatesValuesDefault,
        setLatestDatesValuesInitial,
        setLatestDatesValuesCurrent,
        setAllDatesValues,
        setAllDatesValuesDefault,
        setAllDatesValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useDatesValues};
